import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="footer">
    <div className="footer-bottom">
      © 2026 Aprendole {' '}
      <a href="mailto:contact@aprendole.com">contact@aprendole.com</a> {' '}
      <Link to="/terms-and-conditions">Termos e Condições</Link> {' '}
      <Link to="/privacy-policy">Política de Privacidade</Link> {' '}
      <Link to="/cookie-policy">Política de Cookies</Link> {' '}
      <Link to="/imprint">Impressum</Link> {' '}
      <span
        onClick={(e) => {
          e.preventDefault();
          if (window.Cookiebot && window.Cookiebot.renew) {
            window.Cookiebot.renew();
          }
        }}
        style={{ cursor: 'pointer', textDecoration: 'none' }}
      >
        Configurações de Cookies
      </span>
    </div>
  </footer>
);

export default Footer;




